<div *nzModalTitle>Add Job to project {{ projectName }}</div>

<app-jobs-form
  [projectId]="nzModalData.projectId"
  (jobsAdded)="onSubmitSuccess()"
></app-jobs-form>
